import { ReactNode, useEffect } from 'react'
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { CreatePaymentIntent } from '@wolfdanepug/common-react'
import { stripeKey } from './constants'
import { useMutation } from '../../lib/useMutation'

export interface StripeProps {
	children: ReactNode | ReactNode[]
	component?: any
	componentProps?: any
}

const stripePromise = loadStripe(stripeKey)

export default function Stripe({
	children,
	component: Component,
	componentProps = {}
}: StripeProps) {
	const [getIntent, { data: intent, loading }] = useMutation(CreatePaymentIntent)

	useEffect(() => {
		getIntent()
	}, [])

	if (loading || !intent) return null

	const options: StripeElementsOptions = {
		appearance: {
			labels: 'floating'
		},
		clientSecret: intent?.clientSecret
	}

	return (
		<Elements stripe={stripePromise} options={options}>
			{children}
			{Component && <Component {...componentProps} />}
		</Elements>
	)
}
